module.exports = __webpack_public_path__ + "static/img/signE.b93ebd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/signE.png
// module id = CU+t
// module chunks = 1